export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14824.be84cd94.jpg";